import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import LcCheckBox from '../../../../components/Form/LcCheckBox';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import WorkService from '../../../../services/WorkService/WorkService';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import Modal from '../../../../components/Dialog/Modal';
import LcLoading from '../../../../components/Generic/LcLoading';
import { PPTextField } from 'processor-plataform-ui';
import WorkTypeService from '../../../../services/WorkTypeService/WorkTypeService';

interface PropsWorkList {
    work: WorkView;
    solicitation: SolicitationView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    idConfirm?: string;
    abortMessage: string;
    idAbort?: string;
    linkedSolicitations?: any;
    workAprovall: Function;
    workTypeMultiple: Function;
}

export interface Validate {
    name: string;
    validateMessage: string;
    valid: boolean;
}

const CloseWork: React.FC<PropsWorkList> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [workService, setWorkService] = useState<WorkService>(new WorkService(props));
    const [workTypeService, setWorkTypeService] = useState<WorkTypeService>(new WorkTypeService(props));
    const [work, setWork] = useState<WorkView>(props.work);
    const [workLinked, setWorkLinked] = useState<WorkView>(props.work);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setWork(props.work);
        // setWorkLinked(props.linkedSolicitations)
    }, [props.work]); // , props.linkedSolicitations

    const Save = async () => {
        if (validateRules() === false) {
            setLoading(false);
            return true;
        }

        setLoading(true);

        try {
            var workToSave = {
                ...work,
                idUser: user.id as number,
                idStatus: 7,
                userListChangeManagementApprovers: (work.userListChangeManagementApprovers == null) ? [] : work.userListChangeManagementApprovers,
            };

            // const resp = await workService.updateWorkNew(workToSave);
            const resp = await workService.updateWork(workToSave);

            if (resp.data.approval === 1) {
                props.workAprovall(resp.data);
            }
            else {
                GetNextWorks();
            }

            if (props.onCloseEvent !== null) {
                props.onCloseEvent(true, resp.data);
            }
        }
        catch (e) {
            debugger;
        }

        setLoading(false);
    }

    const GetNextWorks = async () => {
        try {
            var workTypeList = await workTypeService.GetNextWorks(work.idWorkType as number);

            if (workTypeList.length > 1) {
                props.workTypeMultiple(workTypeList);
            }
        }
        catch (error) {
            debugger;
        }
    }

    const [validations, setValidations] = useState<Validate[]>([]);

    const validateRules = () => {
        var validationsChecks: Validate[] = [];

        if (work.workRealized == null || !(work.workRealized.length > 0)) {
            validationsChecks.push({
                name: 'workRealized',
                validateMessage: 'Deve possuir descrição da atividade realizada.',
                valid: false
            });
        }

        setValidations(validationsChecks);

        return validationsChecks.length === 0;
    }

    async function changeData(event: any) {
        const { name, value } = event.target;
        setWork({ ...work, [name]: value.replace(/(?:\r\n|\r|\n)/g, "<br/>") });
    };

    const setClose = () => {
        if (props.onCloseEvent != null) props.onCloseEvent(false);
    }

    return (
        <Modal title={'Encerrar trabalho'} visible={props.open} close={() => setClose()}>
            <LcLoading loading={loading} label={"Carregando..."}>
                <div style={{ padding: '1rem' }}>
                    <LCFlexContainer spacing={2}>
                        <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                            <LcCheckBox
                                name={'show'}
                                title={'Visivel para o solicitante'}
                                checked={false}
                                onChange={() => setWork({ ...work, externalComment: !work.externalComment })} />
                        </LCFlexItem>
                        <LCFlexItem xs={8} sm={8} md={8} lg={8}>
                            <div style={{ width: "150%" }}
                                children={
                                    <PPTextField
                                        required
                                        multiline
                                        onChange={changeData}
                                        label={'Detalhes'}
                                        name={'workRealized'}
                                        minRows={4}
                                        maxRows={4}
                                        help={validations.find(x => 'workRealized' === x.name)?.validateMessage}
                                        error={validations.find(x => 'workRealized' === x.name) !== undefined}
                                    />
                                }
                            />
                        </LCFlexItem>
                        <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                            <div className="row">
                                <button
                                    style={{ margin: '10px' }}
                                    className={'lc-button bg-info'}
                                    id={'Ok'}
                                    color={"primary"}
                                    onClick={() => Save()}>
                                    Ok
                                </button>
                                <button
                                    id={'Cancelar'}
                                    color={"primary"}
                                    style={{ margin: '10px' }}
                                    className={'lc-button bg-info'}
                                    onClick={() => {
                                        if (props.onCloseEvent != null) {
                                            props.onCloseEvent(false);
                                        }
                                    }}>
                                    Cancelar
                                </button>
                            </div>
                        </LCFlexItem>
                    </LCFlexContainer>
                </div>
            </LcLoading>
        </Modal>
    );
};

export default CloseWork;